import request from '@/utils/request'

// 获取用户关联的医生列表
export function fetchDoctor(query) {
  return request({
    url: '/api/v1/user/doctors',
    baseURL: 'other',
    method: 'get',
    params: query
  })
}
